import { CustomerType } from "@origin-digital/platform-enums";
import { getMcAppFromBaseProps } from "../lib/baseProps";
import {
  IBaseProps,
  IMcAppType,
  NavFlow,
  Tab,
  CommonParameters,
} from "../mcApp.types";

const baseProps = {
  path: "/my-account/self-meter-read",
  navFlow: NavFlow.FOCUS,
  parent: Tab.MORE,
};

const createSelfMeterReadMcApp = ({
  name,
  ...props
}: IBaseProps): IMcAppType[] => {
  name = `selfMeterRead${name}`;
  return [
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_SAP`,
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_MAGICLINK`,
      magiclinkPath: "/task/smr",
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_KRAKEN`,
      path:
        "/my/feedback/\\?formCode=rx_self_meter_read&title=Submit%20a%20meter%20read",
      intent: name,
      customerType: CustomerType.kraken,
      ignorePathMapping: true,
    }),
  ];
};

const selfMeterReadApps: IBaseProps[] = [
  {
    name: "",
    subPath: "",
    description: "Self Meter Read landing page",
    title: "Self meter read",
    ...baseProps,
  },
  {
    name: "EnterRead",
    subPath: "accounts/:caid/enter-reading",
    parameters: {
      required: ["caid"],
      properties: { caid: CommonParameters.caid },
    },
    description: "Self Meter Read Enter read page",
    title: "Enter reading",
    ...baseProps,
  },
];

export const selfMeterRead: IMcAppType[] = selfMeterReadApps.flatMap((app) =>
  createSelfMeterReadMcApp(app)
);
